import React from "react";
import { API_URL } from "../../../../constants/api";
import { apiRequest } from "../../../../utils/api_service";
import {
  Checkbox,
  FormControlLabel,
  TextField,
  Chip,
  InputAdornment
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import {
  getSearchedProperty,
  getPhoneNumberWithMask
} from "../../../../utils/generic";
import {
  IsSectionVisible,
  removeDuplicates,
  sortArray
} from "../../../../utils/helper";
import PaginationControlled from "../../../common/pagination/pagination";
import { SECTIONS } from "../../../../constants/appConstants";
import "./SiteProfileTable.less";

class TenantContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantId: props.tenantId,
      tenantContactsList: [],
      searchContactText: "",
      isShowInActive: false,
      pageNo: 0,
      rowsPerPagination: 25
    };
  }

  componentDidMount() {
    //fetch list data
    const {tenantId} = this.state;
    tenantId && this.getTenantContactsList(tenantId);
  }

  /** tenant contact list */
  getTenantContactsList = tenantId => {
    const params = {
      tenantId: tenantId //tenantId, //tenantId? tenantId : this.state.tenantId
    };
    apiRequest({
      url: API_URL.tenantContact.GetTenantContacts,
      params
    }).then(({ data: List }) => {
      this.setState({
        tenantContactsList: List
      });
    });
  };

  /** filter lsit */
  getFilterList = listData => {
    const { searchContactText, isShowInActive } = this.state;

    const year = new Date().getFullYear();
    const day = new Date().getDate();
    const month = new Date().getMonth();

    if (!isShowInActive) {
      listData =
        listData?.filter(
          f =>
            f.ExpireDate == null ||
            (f.ExpireDate &&
              new Date(
                new Date(f.ExpireDate).getFullYear(),
                new Date(f.ExpireDate).getMonth(),
                new Date(f.ExpireDate).getDate()
              ) >= new Date(year, month, day))
        ) || [];
    }

    const searchList = getSearchedProperty(
      listData,
      searchContactText,
      "UserName"
    );

    return searchContactText ? searchList : listData;
  };

  /** update row count */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  render() {
    const {
      tenantContactsList,
      searchContactText,
      isShowInActive,
      pageNo,
      rowsPerPagination,
    } = this.state;

    const tenantContactsListing = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.CONTACT_LIST
    );

    const filterList = this.getFilterList(tenantContactsList);

    return (
      <div className={"col-xs-12"}>
        <div className={"row "}>
          <div className={"col-xs-12"}>
            <TextField
              id={"contact-search-required"}
              className={"searchContact"}
              label={"Contact Name"}
              value={searchContactText}
              onChange={event =>
                this.setState({ searchContactText: event.target.value })}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <FormControlLabel
              className={"checkbox-filter"}
              control={
                <Checkbox
                  id={"IsAccessible1"}
                  color={"primary"}
                  defaultValue={isShowInActive}
                  checked={isShowInActive}
                  onChange={event =>
                    this.setState({ isShowInActive: event.target.checked })}
                />
              }
              label={"Include Inactive"}
            />
          </div>
        </div>
        <div className={"row "}>
          <div className={"col-xs-12"}>
            <div className={"site-profile-table-div "}>
              {tenantContactsListing ? (
                <table
                  className={"site-profile-table"}
                  style={{ fontWeight: "200 !important" }}
                >
                  <thead>
                    <tr
                      className={"blue-custom-title"}
                      style={{ borderTop: "3px solid #FFFFFF" }}
                    >
                      <th
                        colSpan={5}
                        style={{
                          fontSize: "15px",
                          textAlign: "center",
                          lineHeight: "25px"
                        }}
                      >
                        {"Tenant Contacts\r"}
                      </th>
                    </tr>
                    <tr
                      className={"blue-custom-title"}
                      style={{ borderTop: "3px solid #FFFFFF" }}
                    >
                      <th className={"w-20"}>{"Data Center"}</th>
                      <th className={"w-10"}>{"Contact Name"}</th>
                      <th className={"w-10"}>{"Phone Number"}</th>
                      <th className={"w-20"}>{"Email"}</th>
                      <th className={"w-40"}>{"Request Permissions"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterList && filterList.length > 0 ? (
                      (
                        (rowsPerPagination > 0
                          ? filterList.slice(
                              pageNo * rowsPerPagination,
                              pageNo * rowsPerPagination +
                                rowsPerPagination
                            )
                          : filterList) || []
                      ).map((item, index) => (
                        <tr key={"contacts" + index}>
                          <td>{item.PropertyName}</td>
                          <td>{item.UserName}</td>
                          <td>
                            {item.Phone == null || item.Phone == ""
                              ? "-"
                              : getPhoneNumberWithMask(item.Phone)}
                          </td>
                          <td>{item.Email}</td>
                          <td>
                            {item.RequestTypes == null
                              ? "-"
                              : sortArray(
                                  removeDuplicates(item.RequestTypes.split(","))
                                )?.map((obj, index) => (
                                  <Chip
                                    key={"chip" + index + "c"}
                                    label={obj}
                                    style={{
                                      margin: 1,
                                      fontSize: "0.7rem",
                                      height: "1.8rem"
                                    }}
                                  />
                                ))}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td style={{ textAlign: "center" }} colSpan={4}>
                          {"No data available\r"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <></>
              )}
            </div>
          </div>
          {filterList && filterList.length > 0 && (
            <div className={"pagination-container"}>
              <PaginationControlled
                tableLength={filterList.length}
                updateRowCount={this.updateRowCount}
                pageNo={pageNo}
                rowsPerPagination={rowsPerPagination}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default TenantContact;
